import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpJobOrderHdrContainerModel } from '../../../../../../models/aggregates/mrp-prodsys/mrp-job-order-hdr-container.model';
import { ApiVisa, Pagination, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class MrpJobOrderReportService extends BaseApiTemplateService<MrpJobOrderHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/job-orders"
    this.httpClient = http;
  }


  public getUnresolvedSalesOrdersByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/unresolved-so-with-job/backoffice-ep?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }


}
